import RxGateAvailableReceiptsBlock from './RxGateAvailableReceiptsBlock';

export default RxGateAvailableReceiptsBlock;
